var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 130,
    viewBox: "0 0 165 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 130C100.899 130 130 100.899 130 65C130 29.1015 100.899 0 65 0C29.1015 0 0 29.1015 0 65C0 100.899 29.1015 130 65 130Z",
    fill: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4723_27815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5326 29.4688H152.533C153.682 29.4688 154.784 29.9253 155.597 30.738C156.409 31.5506 156.866 32.6528 156.866 33.8021V55.4687C156.866 56.618 156.409 57.7202 155.597 58.5329C154.784 59.3455 153.682 59.8021 152.533 59.8021H35.5326C34.3833 59.8021 33.2811 59.3455 32.4684 58.5329C31.6558 57.7202 31.1992 56.618 31.1992 55.4687V33.8021C31.1992 32.6528 31.6558 31.5506 32.4684 30.738C33.2811 29.9253 34.3833 29.4688 35.5326 29.4688V29.4688Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0005 36.3984H68.4672C67.0312 36.3984 65.8672 37.5625 65.8672 38.9984C65.8672 40.4344 67.0312 41.5984 68.4672 41.5984H91.0005C92.4365 41.5984 93.6005 40.4344 93.6005 38.9984C93.6005 37.5625 92.4365 36.3984 91.0005 36.3984Z",
    fill: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.601 47.6641H68.4672C67.0312 47.6641 65.8672 48.8281 65.8672 50.2641C65.8672 51.7 67.0312 52.8641 68.4672 52.8641H106.601C108.036 52.8641 109.201 51.7 109.201 50.2641C109.201 48.8281 108.036 47.6641 106.601 47.6641Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9341 44.637C58.9341 37.6966 53.3078 32.0703 46.3674 32.0703C39.4271 32.0703 33.8008 37.6966 33.8008 44.637C33.8008 51.5774 39.4271 57.2036 46.3674 57.2036C53.3078 57.2036 58.9341 51.5774 58.9341 44.637Z",
    fill: "#98A2B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5866 48.705C46.6624 48.7048 47.7073 48.3448 48.555 47.6823L51.22 50.3473L52.0771 49.4902L49.4112 46.8243C50.081 45.9583 50.4377 44.891 50.4233 43.7964C50.4088 42.7017 50.0241 41.6442 49.3317 40.7962C48.6393 39.9482 47.6801 39.3597 46.6104 39.1267C45.5407 38.8936 44.4237 39.0297 43.4413 39.5128C42.4588 39.9959 41.669 40.7975 41.2005 41.7869C40.732 42.7763 40.6123 43.8953 40.8612 44.9614C41.11 46.0275 41.7126 46.9779 42.5707 47.6577C43.4288 48.3375 44.4919 48.7067 45.5866 48.705ZM45.5866 40.2168C46.3065 40.2168 47.0103 40.4303 47.6089 40.8303C48.2075 41.2302 48.674 41.7987 48.9495 42.4639C49.225 43.129 49.2971 43.8609 49.1567 44.567C49.0162 45.273 48.6695 45.9216 48.1605 46.4307C47.6514 46.9398 47.0028 47.2864 46.2967 47.4269C45.5907 47.5673 44.8588 47.4952 44.1936 47.2197C43.5285 46.9442 42.96 46.4777 42.5601 45.8791C42.1601 45.2805 41.9466 44.5767 41.9466 43.8568C41.9466 42.8914 42.3301 41.9656 43.0127 41.283C43.6954 40.6003 44.6212 40.2168 45.5866 40.2168Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4723_27815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.535 68.4688H22.5345C20.1413 68.4688 18.2012 70.4088 18.2012 72.8021V94.4687C18.2012 96.862 20.1413 98.8021 22.5345 98.8021H139.535C141.928 98.8021 143.868 96.862 143.868 94.4687V72.8021C143.868 70.4088 141.928 68.4688 139.535 68.4688Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0005 75.3984H55.4672C54.0312 75.3984 52.8672 76.5625 52.8672 77.9984C52.8672 79.4344 54.0312 80.5984 55.4672 80.5984H78.0005C79.4365 80.5984 80.6005 79.4344 80.6005 77.9984C80.6005 76.5625 79.4365 75.3984 78.0005 75.3984Z",
    fill: "#D0D5DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6005 86.6641H55.4672C54.0312 86.6641 52.8672 87.8281 52.8672 89.2641C52.8672 90.7 54.0312 91.8641 55.4672 91.8641H93.6005C95.0365 91.8641 96.2005 90.7 96.2005 89.2641C96.2005 87.8281 95.0365 86.6641 93.6005 86.6641Z",
    fill: "#EAECF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9341 83.637C45.9341 76.6966 40.3078 71.0703 33.3674 71.0703C26.4271 71.0703 20.8008 76.6966 20.8008 83.637C20.8008 90.5774 26.4271 96.2036 33.3674 96.2036C40.3078 96.2036 45.9341 90.5774 45.9341 83.637Z",
    fill: "#98A2B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5866 87.705C33.6624 87.7048 34.7073 87.3448 35.555 86.6823L38.22 89.3473L39.0771 88.4902L36.4112 85.8243C37.081 84.9583 37.4377 83.891 37.4233 82.7964C37.4088 81.7017 37.0241 80.6442 36.3317 79.7962C35.6393 78.9482 34.6801 78.3597 33.6104 78.1267C32.5407 77.8936 31.4237 78.0297 30.4413 78.5128C29.4588 78.9959 28.669 79.7975 28.2005 80.7869C27.732 81.7763 27.6123 82.8953 27.8612 83.9614C28.11 85.0275 28.7126 85.9779 29.5707 86.6577C30.4288 87.3375 31.4919 87.7067 32.5866 87.705ZM32.5866 79.2168C33.3065 79.2168 34.0103 79.4303 34.6089 79.8303C35.2075 80.2302 35.674 80.7987 35.9495 81.4639C36.225 82.129 36.2971 82.8609 36.1567 83.567C36.0162 84.273 35.6695 84.9216 35.1605 85.4307C34.6514 85.9398 34.0028 86.2864 33.2967 86.4269C32.5907 86.5673 31.8588 86.4952 31.1936 86.2197C30.5285 85.9442 29.96 85.4777 29.5601 84.8791C29.1601 84.2805 28.9466 83.5767 28.9466 82.8568C28.9466 81.8914 29.3301 80.9656 30.0127 80.283C30.6954 79.6003 31.6212 79.2168 32.5866 79.2168Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4723_27815",
    x: 29.1992,
    y: 27.4688,
    width: 135.666,
    height: 40.3359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4723_27815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4723_27815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4723_27815",
    x: 16.2012,
    y: 66.4688,
    width: 135.666,
    height: 40.3359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4723_27815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4723_27815",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccount);
export default __webpack_public_path__ + "static/media/NoAccount.eabd1772084b752719a9e7db4af0693c.svg";
export { ForwardRef as ReactComponent };